import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`14 年以來，Amazon Web Services 一直是世界上服務豐富、應用廣泛的雲端服務平台。AWS 為客戶提供超過 175 種功能全面的雲端服務，包括運算、儲存、資料庫、聯網、分析、機器人、機器學習與人工智慧、物聯網、行動、安全、混合雲、虛擬和擴增實境(VR 和 AR)、媒體，以及應用開發、部署和管理等方面，遍及 24 個地理區域內的 77 個可用區域(Availability Zones)，並已公佈計畫在印尼、日本和西班牙建立 3 個 AWS 地理區域、9 個可用區域。全球超過百萬客戶信任 AWS，包含發展迅速的新創公司、大型企業和政府機構。AWS 協助客戶強化自身基礎設施，提高營運上的彈性與應變能力，同時降低成本。欲瞭解更多 AWS 的相關資訊，請至：`}<a parentName="p" {...{
        "href": "https://aws.amazon.com"
      }}>{`https://aws.amazon.com`}</a>{` 。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      